import React, { Component } from "react";
import { connect } from "react-redux";

import {
  Modal,
  ModalHeader,
  ModalBody,
  FormGroup,
  Label,
  Button,
} from "reactstrap";
import {
  POIacknowledge_close,
  POAcknowledgeInputChangeValue,
  SubmitPOiacknowledge,
} from "../../../store/PurchaseOrder/actions";
import { AvForm, AvField } from "availity-reactstrap-validation";

class POIacknowledgeModel extends Component {
  constructor(props) {
    super(props);
    this.state = {};
    this.ChangeHandeler = this.ChangeHandeler.bind(this);
  }
  ChangeHandeler(e) {
    this.props.POAcknowledgeInputChangeValue({
      key: e.target.name,
      value: e.target.value,
    });
  }
  handleValidSubmit() {
    this.props.SubmitPOiacknowledge(this.props.POIacknowledgeData);
  }

  render() {
    return (
      <React.Fragment>
        <Modal
          isOpen={this.props.POIacknowledge_Model}
          backdrop="static"
          centered
          size="lg"
        >
          <ModalHeader toggle={() => this.props.POIacknowledge_close()}>
            Product Item Acknowledge
          </ModalHeader>

          <ModalBody>
            <AvForm
              className="form-horizontal"
              onValidSubmit={() => this.handleValidSubmit()}
              ref={(c) => (this.addForm = c)}
            >
              <FormGroup className="mb-0">
                <Label htmlFor="Remarks" className="col-form-label ">
                  Acknowledge:
                </Label>
                <AvField
                  name="description"
                  id="description"
                  type="textarea"
                  className="form-control"
                  placeholder="Enter Description"
                  value={
                    this.props.POIacknowledgeData.description == null
                      ? ""
                      : this.props.POIacknowledgeData.description
                  }
                  rows="7"
                  validate={{
                    required: { value: true },
                  }}
                  onChange={this.ChangeHandeler}
                />
              </FormGroup>
              <div className="float-right">
                <Button
                  type="reset"
                  color="light"
                  className="waves-effect waves-light mr-2"
                  onClick={() => this.props.POIacknowledge_close()}
                >
                  Cancel
                </Button>
                <Button
                  type="sudmit"
                  color="primary"
                  className="waves-effect waves-light mr-2"
                  // onClick={() => {
                  //   this.PurchaseOrderRowData(this.props.poVendData);
                  // }}
                >
                  Submit
                </Button>
              </div>
            </AvForm>
          </ModalBody>
        </Modal>
      </React.Fragment>
    );
  }
}

const mapStatetoProps = (state) => {
  const { POIacknowledgeData, POIacknowledge_Model } = state.PurchaseOrder;
  return {
    POIacknowledgeData,
    POIacknowledge_Model,
  };
};

export default connect(mapStatetoProps, {
  POIacknowledge_close,
  SubmitPOiacknowledge,
  POAcknowledgeInputChangeValue,
})(POIacknowledgeModel);
